export const userRoles = ['admin', 'user'] as const;
export type UserRole = (typeof userRoles)[number];

export interface WebUser {
  id: number;
  clientId: number;
  email: string;
  role: UserRole;
  name: string;
}

export interface EditWebUser extends Omit<WebUser, 'clientId'> {
  currentPassword: string;
  newPassword: string;
}

export interface NewWebuser {
  email: string;
  name: string;
  currentPassword: string; // it is called currentPassword in the UserDialog
  role: UserRole;
}
